"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function UserDetails24Svg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { d: "M7.5,5 C9.98528137,5 12,7.01471863 12,9.5 C12,10.8112169 11.4391944,11.9914507 10.5443544,12.81393 C12.6055331,13.9899752 14,16.3272991 14,19 L14,19 L12,19 C12,16.2200879 9.96491939,14 7.5,14 C5.03508061,14 3,16.2200879 3,19 L3,19 L1,19 C1,16.3272991 2.39446689,13.9899752 4.45621479,12.8117955 C3.56080565,11.9914507 3,10.8112169 3,9.5 C3,7.01471863 5.01471863,5 7.5,5 Z M23,13 L23,15 L16,15 L16,13 L23,13 Z M7.5,7 C6.11928813,7 5,8.11928813 5,9.5 C5,10.8807119 6.11928813,12 7.5,12 C8.88071187,12 10,10.8807119 10,9.5 C10,8.11928813 8.88071187,7 7.5,7 Z M23,9 L23,11 L14,11 L14,9 L23,9 Z", id: `userdetails24-${id0}` })),
        react_1.default.createElement("g", { id: "user-details-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("mask", { id: "mask-2", fill: "white" },
                react_1.default.createElement("use", { xlinkHref: `#userdetails24-${id0}` })),
            react_1.default.createElement("use", { id: "Mask", fill: "#000000", xlinkHref: `#userdetails24-${id0}` })));
}
function UserDetails24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(UserDetails24Svg, Object.assign({}, svgProps)));
}
exports.default = UserDetails24;
//# sourceMappingURL=UserDetails24.js.map